import $ from 'jquery';

class BBPress {
    constructor () {
        this.$forumSelect = $('.js-forum-select');

        if (this.$forumSelect.length) {
            this.$forumSelect.on('change', $.proxy(this.forumSelect, this));
        }
    }

    forumSelect (e) {
        const $elem = $(e.currentTarget);
        const url = $elem.find(":selected").data('url');

        if (url) {
            window.location.href = url;
        }
    }
}

export default BBPress;
